import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import { WorkspaceSignupView } from '@/features/iam/workspaces/WorkspaceSignupView/index'
import { WorkspaceSignupViewModel } from '@/features/iam/workspaces/WorkspaceSignupView/WorkspaceSignupViewModel'
import { useScopedViewModel } from '@/hooks/view-model-hooks'
import { useDocumentTitle } from '@/hooks/document-title'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { FormContainer } from '@/components/FormContainer'
import { useLightDarkFn } from '@/features/shell/theming/color-scheme-hooks'

export default observer(function WorkspaceSignupViewContainer() {
  const vm = useScopedViewModel(
    ({ iam, shell }) =>
      new WorkspaceSignupViewModel(
        iam.session,
        iam.userStore,
        iam.workspaceStore,
        iam.workspaceMemberStore,
        shell.createSnackbarErrorHandler,
        () => iam.authStore.logout(),
      ),
  )

  useDocumentTitle('Sign up')

  const lightDark = useLightDarkFn()

  const formId = useId()
  const isPending = vm.completeRegistration.pending
  const showLogoutButton = !vm.externalCustomerEnabled

  return (
    <WorkspaceSignupView
      workspaceLogoUrl={lightDark(
        vm.workspace.branding.logos.icon,
        vm.workspace.branding.logos.iconWhite,
      )}
      workspaceName={vm.workspace.name}
      isPending={isPending}
      isLogoutVisible={showLogoutButton}
      onLogout={vm.logout}
      formId={formId}
      testId="workspace-signup-page"
      continueButtonTestId="continue-button"
      logoutButtonTestId="logout-button"
    >
      <FormContainer
        compact
        id={formId}
        disabled={isPending}
        onSubmit={vm.completeRegistration}
      >
        <TextFieldContainer
          required
          model={vm}
          field="firstName"
          label="First name"
          placeholder="e.g. Jane"
          testId="first-name-input"
          hintTestId="first-name-input-hint"
        />

        <TextFieldContainer
          required
          model={vm}
          field="lastName"
          label="Last name"
          placeholder="e.g. Smith"
          testId="last-name-input"
          hintTestId="last-name-input-hint"
        />

        <TextFieldContainer
          required
          model={vm}
          field="phoneNumber"
          name="phone"
          label="Phone number"
          placeholder="e.g. 305-123-4567"
          testId="phone-input"
          hintTestId="phone-input-hint"
        />
      </FormContainer>
    </WorkspaceSignupView>
  )
})
